import React, { useState } from "react";
import InputMask from 'react-input-mask';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import {
  TextField,
  Container,
  Grid
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment/moment";
import axios from "axios";
import { loadingPanel } from "../../../../CommonComponents/CommonFunction";
import { ShowSucess } from "../../../../_helper/helper";

const DocTypeModel = (props) => {
  const descriptionElementRef = React.useRef(null);
  const existdata = props.data;
  const [selectedRecordOption, setSelectedRecordOption] = useState("All");
  const [errors, setErrors] = useState({});
  const [isloading, setIsloading] = useState(false);

  const [formData, setFormData] = useState({
    id: existdata?.ID ? existdata?.ID : null,
    docType: existdata?.DocType ? existdata?.DocType : null,
    category: existdata?.Category ? existdata?.Category : 'Document',
    descr: existdata?.Descr ? existdata?.Descr : null,
    usageStatus: existdata?.Usage_Status ? existdata?.Usage_Status : 'Active',
  });
  console.log('formData', formData, existdata);
  const { reloadPage = false } = props;
  const handleChange = (e) => {
    console.log('date', e);

    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // props.updateCurrentRecordinBulk({...formData,[name]: value?.toUpperCase()})
    validatePage();
  };
  const handleChangeDt = (e, name) => {
    console.log('datellll', e?.$d, name);
    const formatDate = e?.$d;

    let date1 = moment(formatDate).format("MM/DD/YYYY");
    setFormData((prev) => ({ ...prev, [name]: date1 }));
    // props.updateCurrentRecordinBulk({...formData,[name]: date1})
  };
  const handleChangeGender = (val, name) => {
    setFormData((prev) => ({ ...prev, [name]: val }));
    // props.updateCurrentRecordinBulk({...formData,[name]: val})
  };


  const validatePage = () => {
    let errorsobj = {};
    let haserror = false;
    if (!formData.category?.trim()) {
      errorsobj['category'] = 'Category Required';
      haserror = true
    } else {
      // delete errorsobj.category;
    }
    if (!formData.docType?.trim()) {
      errorsobj['docType'] = 'Document Type Required';
      haserror = true
    } else {
      // delete errorsobj.docType;
    }
    // if(!formData.descr?.trim()){
    //     errorsobj['descr'] = 'Description Required';
    //     haserror = true
    // }else{
    //     // delete errorsobj.descr;
    // }
    setErrors(errorsobj)
    return haserror;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const transformedData = Object.fromEntries(
      Object.entries(formData).map(([k, v]) => [
        k,
        typeof v === "string" ? v.toUpperCase() : v,
      ])
    );
    console.log(transformedData, 'transformedData2211')

    if (validatePage()) {
      return false
    }


    setIsloading(true)
    let payload = {
      "category": formData.category,
      "docType": formData.docType,
      "descr": formData.descr,
      "usageStatus": formData.usageStatus
    };
    if (existdata?.ID && props?.isUpdate) {
      payload = {
        ...payload,
        "id": existdata?.ID
      }
    }
    console.log("payload", payload, existdata?.ID, props?.isUpdate);
    let updateUrl = props?.isUpdate
      ? `${process.env.REACT_APP_API_DOTNET_URL}/LkOjaAnnouncementDocument/UpdateLkDocument`
      : `${process.env.REACT_APP_API_DOTNET_URL}/LkOjaAnnouncementDocument/CreateLkAnnouncementDocument`;
    let method = props?.isUpdate ? 'put' : 'post';
    try {
      // axios
      //   .post(
      //     // `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global?pageNumber=1&pageSize=100000`,
      //     `${process.env.REACT_APP_API_DOTNET_URL}/LkOjaAnnouncementDocument/${updateUrl}`,
      //     payload,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${sessionStorage.getItem(
      //           "jwt_access_token"
      //         )}`,
      //       },
      //     }
      //   )
      axios({
        method: method, // 'put' or 'post'
        url: updateUrl,
        data: payload, // your request body
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem(
            "jwt_access_token"
          )}`,
        },
      })
        .then((response) => {
          console.log("ddd", props.documentOptions, response.data);
          let updateObj = { id: existdata?.ID, ContentType: payload.docType, Description: payload.descr, Category: payload.category, CreatedDate: moment().format("YYYY-MM-DD"), CreatedBY: null };
          if (props?.isUpdate) {
            props.setDocumentOptions((documentOptions) =>
              documentOptions.map((d) => d.id === existdata?.ID ? updateObj : d)
            );
          } else {
            props.setDocumentOptions((documentOptions) => [...documentOptions, updateObj]);
          }
          if (!props?.isUpdate && props?.getDocumentList) {
            props.getDocumentList();
          }
          props.handleClose()
          setIsloading(false)
          console.log("response", response.data, props?.isUpdate);
          ShowSucess(response?.data || (props?.isUpdate ? "Document updated successfully." : "Document added successfully."));
          // props.setDocumentOptions({...props.documentOptions,updateObj})
          //   props.setDocumentOptions({...props.documentOptions,payload})
          if (reloadPage) {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        })
        .catch((error) => {
          setIsloading(false)
          console.warn("Cannot retrieve user data", error);
        });
    } catch (err) {
      setIsloading(false)
      // setPositionTitleOptions({ data: [], isLoading: false });
    }

  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        open={props.isOpen}
        onClose={props.handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>{!props?.isUpdate ? "Add" : "Update"} Document Type </div>
            <div className="d-flex justify-content-end ">
              <div
                attrBtn={{
                  className: "m-1",
                  color: "primary",
                  onClick: props.handleClose,
                }}
                onClick={props.handleClose}
              >
                X
              </div>
            </div>{" "}
          </div>
        </DialogTitle>
        <DialogContent dividers={"paper"} style={{ minWidth: "600px" }}>
          {isloading ? loadingPanel() : null}
          <form>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} key={"Category"}>


                <TextField
                  margin="dense"
                  className="flex w-full "
                  variant="outlined"
                  select
                  SelectProps={{ native: true }}
                  style={{
                    width: "100%",
                  }}
                  size="small"
                  inputProps={{
                    style: {
                      fontSize: "14px",
                      color: "black",
                      paddingTop: "12px",
                    },
                  }}
                  label={'Category'}
                  rows={5}
                  name={'category'}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    console.log("e.target.value", e.target.value);

                    handleChangeGender(e.target.value, "category");
                  }}
                  //   error={errors['category'] ? true : false}
                  //   helperText={errors['category']}
                  value={formData["category"] || ""}
                > <option value={""} disabled>
                    Select  Category
                  </option>
                  {
                    [{ name: 'Licensing', value: 'Licensing' }, { name: 'Education', value: 'Education' }, { name: 'Document', value: 'Document' }].map((option, index) => (
                      <option key={index} value={option.value}  >
                        {option.name}
                      </option>
                    ))}
                </TextField>
                {errors.category ? <p style={{ color: "red", fontSize: "10px" }}>{errors.category}</p> : null}

                {/* <TextField
                  fullWidth
                  size="small"
                  label={"Category *"}
                  name={"category"}
                  type={"text"}
                  value={formData["category"] || ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    maxLength: 50,style: {  textTransform: "uppercase" },
                  }}
                /> */}

              </Grid>
              <Grid item xs={6} sm={6} key={"Doc Type"}>
                <TextField
                  fullWidth
                  size="small"
                  className="mt-2"
                  label={"Doc type *"}
                  name={"docType"}
                  type={"text"}
                  value={formData["docType"] || ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    maxLength: 50, style: { textTransform: "NONE" },
                  }}
                />
                {errors.docType ? <p style={{ color: "red", fontSize: "10px" }}>{errors.docType}</p> : null}
              </Grid>
              <Grid item xs={12} sm={12} key={"Description"}>
                <TextField
                  fullWidth
                  size="small"
                  label={"Description *"}
                  name={"descr"}
                  type={"text"}
                  value={formData["descr"] || ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    maxLength: 300,
                  }}
                />
                {errors.descr ? <p style={{ color: "red", fontSize: "10px" }}>{errors.descr}</p> : null}

              </Grid>
              <Grid item xs={12} md={12}>
                <FormLabel
                  className="mt-2 mr-2"
                  style={{ marginRight: "10px", color: "#000000de" }}
                >
                  Status :{" "}
                </FormLabel>
                <FormControl component="fieldset">
                  <RadioGroup
                    value={formData["usageStatus"] || ""}
                    onChange={(event) => {
                      handleChangeGender(event.target.value, "usageStatus");
                    }}
                    row
                  >
                    <FormControlLabel
                      value="Active"
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value="InActive"
                      control={<Radio />}
                      label="InActive"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              color="primary"
              type="button"
              style={{ marginTop: 20 }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default DocTypeModel;
